import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogTitle: {
      fontFamily: "Lato",
      fontSize: "1.5rem",
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.21,
      letterSpacing: "normal",
      color: theme.palette.primary.main
    },
    searchField: {
      marginBottom: '16px',
    },
    iconGrid: {
      maxHeight: '400px',
      overflowY: 'auto',
      padding: '8px'
    },
    iconButton: {
      border: '1px solid #ddd',
      borderRadius: '8px',
      padding: '12px',
      margin: '2px',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        borderColor: theme.palette.primary.main,
      }
    },
    icon: {
      width: '24px',
      height: '24px',
    },
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '200px',
      textAlign: 'center'
    },
    triggerButton: {
      minWidth: '150px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
  })
);